import React from 'react';

const SettingsPanel = ({ min, max, dispatch }) => (
    <div className="flex flex-col gap-8">
        <div className="flex flex-col gap-3">
            <label htmlFor="inv-min-stock" className="text-[10px] font-black uppercase tracking-[0.2em] text-gray-400 ml-1">Minimum / Low Stock (Red)</label>
            <input
                id="inv-min-stock"
                type="number"
                value={min || 0}
                onChange={(e) => dispatch({ type: 'SET_FIELD', field: 'min', value: e.target.value })}
                className="w-full px-6 py-4 bg-red-50/30 border-2 border-red-100/50 rounded-2xl outline-none focus:bg-white focus:border-red-500/30 font-black text-red-600 text-xl transition-all shadow-inner"
            />
        </div>
    </div>
);

export default SettingsPanel;
